UsersLists:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/QueryGroupSeq"
    - $ref: "../parameters.yaml#/QueryKeyword"
    - $ref: "../parameters.yaml#/QueryUserRole"
    - $ref: "../parameters.yaml#/QueryUserStatus"
    - $ref: "../parameters.yaml#/QueryUserLimit"
    - $ref: "../parameters.yaml#/QueryOffset"
  
  get:
    operationId: getUsersLists
    tags:
      - Users
    summary: ユーザーの照会
    description: |
      ### ユーザーを照会します。 <br><br>

      **ソート基準**は`user_seq(ユーザー識別コード)`の降順です。

      > 💡 &nbsp; **Note**  <br><br>
      **limit, offset**  
      limitとoffsetはページング処理の際に使用してください。  <br><br>
      
      ### 例) 1ページに200件出力する場合の「limit」と「offset」の設定
      &nbsp;&nbsp;&nbsp;&nbsp; 1ページ ▶︎ limit=200 / offset=0
      &nbsp;&nbsp;&nbsp;&nbsp; 2ページ ▶︎ limit=200 / offset=200
      &nbsp;&nbsp;&nbsp;&nbsp; 3ページ ▶︎ limit=200 / offset=400

    responses:
      "200":
        description: ユーザー照会成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/UserList"
      "default":
        description: ユーザー照会失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"

UsersCreate:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"

  post:
    operationId: postUsersCreate
    tags:
      - Users
    summary: ユーザーの追加
    description: |
      ### 新しいユーザーを追加します。 <br><br>

      **role**  

      ユーザーには以下の4種類のroleのいずれかを割り当てます。
      1. SUPERUSER : 契約管理者
      2. MANAGER : 一般管理者
      3. USER : ユーザー
      4. GUEST : ゲスト

      **gmt**  

      ユーザーのGMT（Greenwich Mean Time）です。
      指定しない場合は、企業情報に設定されている値が設定されます。

    requestBody:
      $ref: "../openapi/requests.yaml#/UserCreateRequest"

    responses:
      "200":
        description: ユーザー追加成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/UserCreate"
      "default":
        description: ユーザー追加失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              User ID Already Exist:
                $ref: "../openapi/response.error.yaml#/UserIDExist"

UsersReadUserSeq:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"

  get:
    operationId: getUsersReadUserSeq
    tags:
      - Users
    summary: ユーザー情報の確認
    description: |
      ### ユーザー情報を確認します。  <br><br>
      
      **regdate**  

      ユーザーの登録日時です。
    
    responses:
      "200":
        description: ユーザー情報確認成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/UserRead"
      "default":
        description: ユーザー情報確認失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              No Required Value:
                $ref: "../openapi/response.error.yaml#/NoRequiredInputValue"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              User Not Found:
                $ref: "../openapi/response.error.yaml#/UserNotFound"

UsersUpdateUserSeq:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathUserSeq"

  post:
    operationId: postUsersUpdateUserSeq
    tags:
      - Users
    summary: ユーザー情報の変更
    description: |
      ### ユーザー情報を修正します。
    
    requestBody:
      $ref: "../openapi/requests.yaml#/UserUpdateRequest"
    
    responses:
      "200":
        description: ユーザー情報修正成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: ユーザー情報修正失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              No Required Value:
                $ref: "../openapi/response.error.yaml#/NoRequiredInputValue"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              User Not Found:
                $ref: "../openapi/response.error.yaml#/UserNotFound"

UsersDelete:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"

  post:
    operationId: postUsersDelete
    tags:
      - Users
    summary: ユーザーの削除
    description: |
      ### ユーザーを削除します。
    
    requestBody:
      $ref: "../openapi/requests.yaml#/UserDeleteRequest"
    
    responses:
      "200":
        description: ユーザー削除成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: ユーザー削除失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              User Not Found:
                $ref: "../openapi/response.error.yaml#/UserNotFound"

GroupsListGroupSeq:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathGroupSeq"
  
  get:
    operationId: getGroupsListGroupSeq
    tags:
      - Groups
    summary: グループの照会
    description: |
      ### グループを照会します。

      特定の `group_seq(グルーブ識別コード)` を指定しない場合、基本グループと第1階層のグループが照会されます。
      
      **基本グループ**は、DirectCloud登録時に自動的に作成されるグループです。
      
       > 💡 &nbsp; **Note**  <br><br>
       **parent_group_seq(親グルーブのグループ識別コード)が0でありながら、depthが0のグループ**は、システムが生成したデフォルトグループですので、変更・削除をしないでください。
    
    responses:
      "200":
        description: グループ照会成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/GroupList"
      "default":
        description: グループ照会失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"

GroupsCreate:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"

  post:
    operationId: postGroupsCreate
    tags:
      - Groups
    summary: グループの追加
    description: |
      ### グループを追加します。
    
    requestBody:
      $ref: "../openapi/requests.yaml#/GroupCreateRequest"
    
    responses:
      "200":
        description: グループ追加成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: グループ追加失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Parent Group Not Found:
                $ref: "../openapi/response.error.yaml#/ParentGroupNotFound"
              Group Name Already Exist:
                $ref: "../openapi/response.error.yaml#/GroupNameExist"
              No More Groups Can Be Added:
                $ref: "../openapi/response.error.yaml#/NoMoreGroupsCanBeAdded"

GroupsReadGroupSeq:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathGroupSeqRequired"
  
  get:
    operationId: getGroupsReadGroupSeq
    tags:
      - Groups
    summary: グループ情報の確認
    description: |
      ### グループの情報を確認します。

    responses:
      "200":
        description: グループ情報確認成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/GroupRead"
      "default":
        description: グループ情報確認失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              No required Input Value:
                $ref: "../openapi/response.error.yaml#/NoRequiredInputValue"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Group Not Found:
                $ref: "../openapi/response.error.yaml#/GroupNotFound"

GroupsUpdateGroupSeq:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathGroupSeq"

  post:
    operationId: postGroupsUpdateGroupSeq
    tags:
      - Groups
    summary: グループ情報の変更
    description: |
      ### グループの情報を変更します。

    requestBody:
      $ref: "../openapi/requests.yaml#/GroupUpdateRequest"
    
    responses:
      "200":
        description: グループ情報変更成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: グループ情報変更失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              No required Input Value:
                $ref: "../openapi/response.error.yaml#/NoRequiredInputValue"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Group Not Found:
                $ref: "../openapi/response.error.yaml#/GroupNotFound"
              Group Name Already Exist:
                $ref: "../openapi/response.error.yaml#/GroupNameExist"

GroupsDelete:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
  
  post:
    operationId: postGroupsDelete
    tags:
      - Groups
    summary: グループの削除
    description: |
      ### グループを削除します。
      
      > 💡 &nbsp; **Note**  <br><br>
      削除対象のグループに下位グループが存在する場合は、同時に削除されます。

    requestBody:
      $ref: "../openapi/requests.yaml#/GroupDeleteRequest"

    responses:
      "200":
        description: グループ削除成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: グループ削除失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Group Not Found:
                $ref: "../openapi/response.error.yaml#/GroupNotFound"

RelationsListUserSeq:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathUserSeq"

  get:
    operationId: getRelationsListUserSeq
    tags:
      - Relations
    summary: ユーザーが所属するグループ情報の照会
    description: |
      ### ユーザーが所属するグループ情報を照会します。

      `user_seq`は照会対象ユーザーの識別コードです。

      `group_seq`はユーザーが所属しているグループの識別コードです。

      `group_user_info_seq`はユーザーとグループの関係情報の識別コードです。
    
    responses:
      "200":
        description: グループ情報照会成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/RelationList"
      "default":
        description: グループ情報照会失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              No required Input Value:
                $ref: "../openapi/response.error.yaml#/NoRequiredInputValue"

RelationsCreate:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"

  post:
    operationId: postRelationsCreate
    tags:
      - Relations
    summary: ユーザーをグループに追加
    description: |
      ### ユーザーをグループに追加します。

    requestBody:
      $ref: "../openapi/requests.yaml#/RelationCreateRequest"
    
    responses:
      "200":
        description: ユーザーのグループへの追加成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/RelationCreate"
      "default":
        description: ユーザーのグループへの追加失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              User Not Found:
                $ref: "../openapi/response.error.yaml#/UserNotFound"
              Group Not Found:
                $ref: "../openapi/response.error.yaml#/GroupNotFound"

RelationsDelete:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
  
  post:
    operationId: postRelationsDelete
    tags:
      - Relations
    summary: ユーザーをグループから削除
    description: |
      ### ユーザーをグループから削除します。
    
    requestBody:
      $ref: "../openapi/requests.yaml#/RelationDeleteRequest"
    
    responses:
      "200":
        description: ユーザーの削除成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: ユーザーの削除失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              User Not Found:
                $ref: "../openapi/response.error.yaml#/UserNotFound"

SharedBoxesListsNode:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"

  get:
    operationId: getSharedBoxesListsNode
    tags:
      - Shared Boxes
    summary: 共有フォルダリストの照会
    description: |
      ### 共有フォルダリストを照会します。

      `node` は照会対象フォルダが存在する親フォルダの識別コードです。
      ノードを指定しない場合、共有フォルダの最上位フォルダのノード "1{2" がデフォルト値として適用されます。

      共有フォルダのノードは "1{2" を接頭語とし、フォルダの階層が下がる毎に3文字ずつノードが追加されます。
    
    responses:
      "200":
        description: 共有フォルダリスト照会成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/SharedBoxList"
      "default":
        description: 共有フォルダリスト照会失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"

SharedBoxesCreateNode:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"

  post:
    operationId: postSharedBoxesCreateNode
    tags:
      - Shared Boxes
    summary: 共有フォルダの追加
    description: |
      ### 共有フォルダを追加します。

      `node` は追加先フォルダの識別コードです。
      追加するフォルダと同名のフォルダが存在する場合はエラーが発生します。
    
    requestBody:
      $ref: "../openapi/requests.yaml#/CreateFolderRequest"
    
    responses:
      "200":
        description: フォルダ追加成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: フォルダ追加失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              No required Input Value:
                $ref: "../openapi/response.error.yaml#/NoRequiredInputValue"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Folder not Exist:
                $ref: "../openapi/response.error.yaml#/FoldernotExist"
              Folder Already Exists:
                $ref: "../openapi/response.error.yaml#/FolderAlreadyExists"

SharedBoxesReadNode:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"

  get:
    operationId: getSharedBoxesReadNode
    tags:
      - Shared Boxes
    summary: 共有フォルダ情報の照会
    description: |
      ### 共有フォルダ情報を照会します。

      `node` は情報照会対象フォルダの識別コードです。

    responses:
      "200":
        description: 共有フォルダ情報照会成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/SharedBoxRead"
      "default":
        description: 共有フォルダ情報照会失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              No required Input Value:
                $ref: "../openapi/response.error.yaml#/NoRequiredInputValue"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              File or Directory Not Exists:
                $ref: "../openapi/response.error.yaml#/FolderOrDirectoryNotExists"

SharedBoxesUpdateNode:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"

  post:
    operationId: postSharedBoxesUpdateNode
    tags:
      - Shared Boxes
    summary: 共有フォルダ情報の変更
    description: |
      ### 共有フォルダ情報を変更します。

      `node` は情報変更対象フォルダの識別コードです。

    requestBody:
      $ref: "../openapi/requests.yaml#/RenameFolderRequest"

    responses:
      "200":
        description: フォルダ情報変更成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: フォルダ情報変更失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              No required Input Value:
                $ref: "../openapi/response.error.yaml#/NoRequiredInputValue"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              File or Directory Not Exists:
                $ref: "../openapi/response.error.yaml#/FolderOrDirectoryNotExists"

SharedBoxesDelete:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"

  post:
    operationId: postSharedBoxesDelete
    tags:
      - Shared Boxes
    summary: 共有フォルダの削除
    description: |
      ### 共有フォルダを削除します。

    requestBody:
      $ref: "../openapi/requests.yaml#/DeleteFolderRequest"

    responses:
      "200":
        description: フォルダ削除成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: フォルダ削除失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Folder not Exists:
                $ref: "../openapi/response.error.yaml#/FoldernotExists"

FoldersPermissionsListsNode:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"

  get:
    operationId: getFoldersPermissionsListNode
    tags:
      - Permission
    summary: 共有フォルダのアクセス権リストの照会
    description: |
      ### 共有フォルダに設定されたアクセス権リストを照会します。

      権限照会は、第１階層のフォルダのノードから可能です。
      - トップフォルダ（「共有」フォルダ）: 1{2
      - 第１階層：1{2XXX
      - 第２階層：1{2XXXAAA

      > 💡 &nbsp; **Note**  <br><br>
      仮に、第３階層のフォルダを照会し、設定された権限が存在しない場合は、上位の第２階層→第１階層の順に継承元の権限を照会します。

      **permission_name**

      DirectCloud APIで使用するアクセスレベルのパラメータは以下のとおりです。
      - **owner**: オーナー
      - **editor**: 編集者
      - **editor2**: 編集者－
      - **viewer**: ダウンローダ
      - **uploader**: アップローダ
      - **uploader2**: 閲覧者+
      - **previewer**: 閲覧者

      <br>
      ※1 「ダウンローダ」および「閲覧者＋」を設定するために使用するDirectCloud APIのパラメータは、それぞれ「viewer」「uploader2」となりますので、ご注意ください。
      <br>
      ※2 「ダウンローダ」および「閲覧者＋」を設定するために使用するDirectCloud APIのパラメータと、管理ページの「アクセス権一括処理」設定で使用する権限名は以下のとおり異なります。

      【DirectCloud API】<br>
      ダウンローダ：viewer <br>
      閲覧者+ ：uploader2 <br>

      【アクセス権一括処理】 <br>
      ダウンローダ：downloader <br>
      閲覧者+ : previewer + <br>

      ※3 副管理者の権限は付与できません。

      権限の詳細につきましては、「共有フォルダへのアクセス権の追加」ページの「権限定義」を参照してください。
    
    responses:
      "200":
        description: アクセス権リスト照会成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/PermissionList"
      "default":
        description: アクセス権リスト照会失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Unknown Error:
                $ref: "../openapi/response.error.yaml#/UnknownError"

FolderPermissionsCreate:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"

  post:
    operationId: postFolderPermissionsCreate
    tags:
      - Permission
    summary: 共有フォルダへのアクセス権の追加
    description: |
      ### 共有フォルダにアクセス権を追加します。

      グループ単位またはユーザー単位でアクセス権を付与することが可能です。<br><br>

      DirectCloud APIで使用するアクセスレベルのパラメータは以下のとおりです。<br>
      - **owner**: オーナー
      - **editor**: 編集者
      - **editor2**: 編集者－
      - **viewer**: ダウンローダ
      - **uploader**: アップローダ
      - **uploader2**: 閲覧者+
      - **previewer**: 閲覧者
      - **NoAccess**: アクセス権の除外


      ※1 「ダウンローダ」および「閲覧者＋」を設定するために使用するDirectCloud APIのパラメータは、それぞれ「viewer」「uploader2」となりますので、ご注意ください。<br>
      ※2 「ダウンローダ」および「閲覧者＋」を設定するために使用するDirectCloud APIのパラメータと、管理ページの「アクセス権一括処理」設定で使用する権限名は以下のとおり異なります。<br>

      【DirectCloud API】<br>
      ダウンローダ：viewer<br>
      閲覧者+ ：uploader2<br>

      【アクセス権一括処理】<br>
      ダウンローダ：downloader<br>
      閲覧者+ : previewer +<br>

      ※3 副管理者の権限は付与できません。<br>
      
      ※4 RequestBodyの「permission_name」に、「NoAccess」と入力してHTTPリクエストを送信することで、上位階層から継承されたアクセス権を、特定のユーザーのみ除外することができます。


      ### 権限定義
      &nbsp; |  Owner<br>(オーナー) | Editor<br>(編集者) | Editor2<br>(編集者-) | Viewer<br>(ダウンローダ) | Uploader2<br>(閲覧者+) | Previewer<br>(閲覧者) | Uploader<br>(アップローダ)
      -- |  :--: | :--: | :--: | :--: | :--: | :--: | :--:
      プレビュー |  〇 | 〇 | 〇 | 〇 | 〇 | 〇 | x
      コメント | 〇 | 〇 | 〇 | 〇 | 〇 | 〇 | x
      オンライン編集 | 〇 | 〇 | 〇 | x | x | x | x
      第2階層以降の<br>フォルダダウンロード | 〇 | 〇 | 〇 | x | 〇 | x | x | x
      ファイルダウンロード | 〇 | 〇 | x | 〇 | x | x | x
      フォルダアップロード | 〇 | x | x | x | x | x | x
      ファイルアップロード | 〇 | 〇 | 〇 | x | 〇 | x | 〇
      第2階層以降の<br>フォルダコピー |  〇 | 〇 | x | x | x | x | x
      ファイルコピー | 〇 | 〇 | x | x | x | x | x
      第2階層以降の<br>フォルダ移動 | 〇 | x | x | x | x | x | x
      ファイル移動 | 〇 | x | x | x | x | x | x
      第2階層以降の<br>フォルダ名前の変更 | 〇 | 〇 | 〇 | x | x | x | x | x
      ファイルの名前の変更 | 〇 | 〇 | x | x | x | x | x
      第2階層以降の<br>フォルダ作成 | 〇 | x | x | x | x | x | x
      第2階層以降の<br>フォルダ削除 | 〇 | x | x | x | x | x | x
      ファイル削除 | 〇 | 〇 | x | x | x | x | x
      ファイル期限 | 〇 | x | x | x | x | x | x
      リンク作成 | 〇 | 〇 | x | x | x | x | x
      バージョン管理 | 〇 | x | x | x | x | x | x
      ファイルロック | 〇 | 〇 | 〇 | x | x | x | x
      添付ファイル送信 | 〇 | 〇 | 〇 | x | x | x | x
      受取フォルダ | 〇 | 〇 | 〇 | x | x | x | x
      ゲスト招待 | 〇 | x | x | x | x | x | x
      アクセス権設定 | 〇 | x | x | x | x | x | x
      フォルダプロパティ | x | x | x | x | x | x | x

    requestBody:
      $ref: "../openapi/requests.yaml#/FolderPermissionRequest"

    responses:
      "200":
        description: アクセス権追加成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: アクセス権追加失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Folder not Exists:
                $ref: "../openapi/response.error.yaml#/FoldernotExists"

FolderPermissionsUpdate:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"
  
  post:
    operationId: postFolderPermissionsUpdate
    tags:
      - Permission
    summary: 共有フォルダのアクセス権の変更
    description: |
      ### 共有フォルダに設定されたアクセス権を変更します。
    
    requestBody:
      $ref: "../openapi/requests.yaml#/UpdateFolderPermissionRequest"
    
    responses:
      "200":
        description: 共有フォルダのアクセス権変更成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: 共有フォルダのアクセス権変更失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Folder not Exists:
                $ref: "../openapi/response.error.yaml#/FoldernotExists"

FolderPermissionsDelete:
  parameters:
    - $ref: "../parameters.yaml#/QueryLanguage"
    - $ref: "../parameters.yaml#/HeaderAccessToken"

  post:
    operationId: postFolderPermissionsDelete
    tags:
      - Permission
    summary: 共有フォルダからアクセス権の削除
    description: |
      ### 共有フォルダに設定されたアクセス権を削除します
    
    requestBody:
      $ref: "../openapi/requests.yaml#/DeleteFolderPermissionRequest"
    
    responses:
      "200":
        description: 共有フォルダのアクセス権削除成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: 共有フォルダのアクセス権削除失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Folder not Exists:
                $ref: "../openapi/response.error.yaml#/FoldernotExists"